import  { IconProps, Icon } from '@chakra-ui/react';
import * as React from 'react';

const PixIcon: React.FC<IconProps> = props => (
  <Icon viewBox="0 0 43.833 43.833" {...props}>
    <path
      d="M34.192 33.52a6.383 6.383 0 0 1-4.55-1.878l-6.563-6.562c-.45-.45-1.27-.45-1.72 0l-6.587 6.588a6.383 6.383 0 0 1-4.551 1.879H8.924l8.335 8.334c2.593 2.593 6.826 2.593 9.419 0l8.36-8.36zM10.194 10.29c1.72 0 3.334.661 4.551 1.878l6.588 6.588a1.214 1.214 0 0 0 1.72 0l6.588-6.561a6.383 6.383 0 0 1 4.55-1.879h.795l-8.361-8.36c-2.593-2.594-6.826-2.594-9.42 0L8.872 10.29Z"
      fill="currentColor"
      stroke="0.264583"
    />
    <path
      d="m41.891 17.222-5.053-5.054a.845.845 0 0 1-.37.08h-2.303c-1.19 0-2.354.476-3.175 1.323l-6.561 6.561a3.17 3.17 0 0 1-2.223.926c-.82 0-1.614-.317-2.222-.926l-6.588-6.588a4.533 4.533 0 0 0-3.175-1.323H7.39a.733.733 0 0 1-.344-.08l-5.08 5.08c-2.593 2.594-2.593 6.827 0 9.42l5.053 5.054a.733.733 0 0 1 .344-.08h2.831c1.19 0 2.355-.476 3.175-1.323l6.588-6.588c1.191-1.19 3.281-1.19 4.472 0l6.561 6.562a4.533 4.533 0 0 0 3.175 1.323h2.302c.133 0 .238.026.37.08l5.054-5.054a6.643 6.643 0 0 0 0-9.393"
      fill="currentColor"
      stroke="0.264583"
    />
  </Icon>
);

export default PixIcon;
